import { jsx as _jsx } from "react/jsx-runtime";
import { LivemarkComponentsContext } from '#pplx/frontend/components/search/markdown/LivemarkComponentsContext.js';
import { logger } from '#pplx/frontend/logger/browser.js';
import React, { useCallback, useMemo, useRef, useState } from 'react';
export function LivemarkComponentsProvider({ children, }) {
    const [components, setComponents] = useState(null);
    const importPromiseRef = useRef(null);
    const loadComponents = useCallback(() => {
        if (components || importPromiseRef.current) {
            return;
        }
        // Loaded on first markdown render so Ask-only bridge components stay out of
        // both the entry chunk and layout-only pages such as /__blank__.
        importPromiseRef.current =
            import('#pplx/frontend/apps/ask/markdown/enriched-ui/livemarkComponents.js')
                .then((m) => setComponents(m.LIVEMARK_COMPONENTS))
                .catch((err) => {
                importPromiseRef.current = null;
                logger.error('Failed to load Livemark components', { error: err });
            });
    }, [components]);
    const contextValue = useMemo(() => ({ components, loadComponents }), [components, loadComponents]);
    return (_jsx(LivemarkComponentsContext.Provider, { value: contextValue, children: children }));
}
//# sourceMappingURL=LivemarkComponentsProvider.js.map